export default {
  mounted() {
    this.handleEvent('toggle-selected', ({ id }) => {
      if (this.el.dataset.toggleSelectedId === id) {
        this.el
          .querySelector(`#${id}-input`)
          .dispatchEvent(new Event('change', { bubbles: true }))
      }
    })
  }
}
